export default __webpack_public_path__ + "static/pay-logo-faa0b08adab61e91cbc80eb073b1478b.png";